// removed by extract-text-webpack-plugin
module.exports = {"title":"l66dGBjev5mPWgLJQP0GV","countChartInfo":"_2ka6OKvVchwjOzyQH2FZCx","countChart":"_2NvAAPrQOYG0xm5Nw0y7bv","chartInfo":"_1FQywIXv4RFn6K_Z8Wddu","chartInfoSelected":"_30bnu9zDVGJIQtryv8SZEY","chartInfoFill":"_1k-wn6cpSEOjCpRiTl40Uz","selectedChartInfo":"_2_S4mNoGdKLdR1-XNGre0R","invoiceId":"_1Rf-kjtf41GZDHcdHiuugz","boxCount":"_1HbYfasradS1gAleP2XPin"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets.new/BoxCountChart/widget.scss
// module id = 1265
// module chunks = 0